import { render, staticRenderFns } from "./ProjectPOACalendar.vue?vue&type=template&id=067d0f98"
import script from "./ProjectPOACalendar.vue?vue&type=script&lang=js"
export * from "./ProjectPOACalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports